import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { UserGuideStatus, UserGuideType } from '@app/reducers/orm/user-guide/user-guide.model';
import { UserGuideService } from '@app/reducers/orm/user-guide/user-guide.service';
import { TrackingService } from '@app/services/tracking.service';
import { TranslatePipe } from '@ngx-translate/core';
import { ChecklistFooterComponent } from '@sb/ui/checklist';
import { SbDialogService } from '@sb/ui/dialog';

import { MeetingSchedulerDialogComponent } from '../meeting-scheduler-dialog/meeting-scheduler-dialog.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'book-a-call-footer',
  templateUrl: './book-a-call-footer.component.html',
  imports: [ChecklistFooterComponent, TranslatePipe],
})
export class BookACallFooterComponent {
  #dialogService = inject(SbDialogService);
  #userGuideService = inject(UserGuideService);
  #trackingService = inject(TrackingService);

  originator = input.required<string>();

  onPrimaryClick() {
    void this.#trackingService.event('Book A Call Link Clicked', {
      originator: this.originator(),
      action: 'book_a_call',
    });
    this.#dialogService.setSize('xl').open(MeetingSchedulerDialogComponent);
  }

  onSecondaryClick() {
    void this.#trackingService.event('Book A Call Link Clicked', {
      originator: this.originator(),
      action: 'no_help_needed',
    });
    void this.#userGuideService
      .trackUserGuide({
        guide: UserGuideType.BOOK_A_CALL,
        status: UserGuideStatus.FINISHED,
      })
      .subscribe();
  }
}
